import React, { useState } from 'react';
import { BrowserRouter as  Link } from "react-router-dom";
import LandingPage from '../Components/LandingPage';
import Fade from 'react-reveal/Fade';
import ScrollUp from '../Components/ScrollUp';
import ElevateAppBar from '../Components/Header';
import BookSegment from '../Components/BookSegment';
import Masonry from 'react-masonry-css';
import AdSense from 'react-adsense';
import DailyQuotes from '../Components/DailyQuotes';
import RasterAd from '../Components/RasterAd';

const Books = ( ) => {

    const [searchTerm, setSearchTerm] = useState('');
    

    const breakPoints = {
        default: 4,
        1100: 3,
        700: 2
    }
    
    return ( 
        
        <div >

        <ElevateAppBar></ElevateAppBar>

        <Fade>
        

        <LandingPage/>

        {/* <LandingButtons></LandingButtons> */}
        
        
        
        </Fade>

        <br/><br/>


        <div className= 'book-container'>

        {/* <DailyQuotes></DailyQuotes> */}

        
        
    
        <div className='genre-title'><h2>Business</h2></div>
        <BookSegment genre= 'business'></BookSegment>

    
        <RasterAd></RasterAd>
      
        <div className='genre-title'><h2>Self-Help</h2></div>
        <BookSegment genre= 'selfhelp'></BookSegment>

        <RasterAd></RasterAd>

        <div className='genre-title'><h2>Biographies</h2></div>
        <BookSegment genre= 'biography'></BookSegment>
        <RasterAd></RasterAd>


        <div className='genre-title'><h2>Children Books</h2></div>
        <BookSegment genre= 'children'></BookSegment>
        <RasterAd></RasterAd>

        <div className='genre-title'><h2>Fiction </h2></div>
        <BookSegment genre= 'fiction'></BookSegment>

        <RasterAd></RasterAd>


        <div className='genre-title'><h2>Politics</h2></div>
        <BookSegment genre= 'politics'></BookSegment>
        <RasterAd></RasterAd>
        
        <div className='genre-title'><h2>History</h2></div>
        <BookSegment genre= 'history'></BookSegment>
        <RasterAd></RasterAd>


        <div className='genre-title'><h2>Science</h2></div>
        <BookSegment genre= 'science'></BookSegment>
        <RasterAd></RasterAd>

        <div className='genre-title'><h2>NY-Times Bestseller</h2></div>
        <BookSegment genre= 'nyctimes'></BookSegment>
        <RasterAd></RasterAd>

        <div className='genre-title'><h2>Popular on Glimbay</h2></div>
        <BookSegment genre= 'popular'></BookSegment>
        
        <RasterAd></RasterAd>

        </div>

        

        <div className= 'end-note'>
                <h3>Not finding the book you want  <br></br>( ˘︹˘ )<Link to= '/contact'><font style= {{color: 'var(--accent)'}}>Contact us!</font></Link></h3>
        </div>

        <ScrollUp/>

        </div>

     );
}
 
export default Books;